module.exports = __webpack_public_path__ + "files/6573820b08ef8b58ebcc8b2a974cc0fb.png";